"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var RateAlert = function RateAlert(props) {
  return _react["default"].createElement("svg", {
    className: props.className,
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(1.000000, 1.000000)"
  }, _react["default"].createElement("path", {
    d: "M14.0002,-0.0003 C6.2802,-0.0003 0.0002,6.2807 0.0002,13.9997 C0.0002,21.7197 6.2802,27.9997 14.0002,27.9997 C21.7202,27.9997 28.0002,21.7197 28.0002,13.9997 C28.0002,6.2807 21.7202,-0.0003 14.0002,-0.0003",
    fill: "#002272"
  }), _react["default"].createElement("path", {
    className: "hvr-icon-fill",
    d: "M19.6182,12.8047 L19.1162,14.3147 C18.5182,16.1047 18.3442,18.0387 18.6112,19.9087 L18.7322,20.7547 C18.7812,21.0977 18.6492,21.4427 18.3832,21.6637 C18.2002,21.8167 17.9722,21.8967 17.7422,21.8967 C17.6362,21.8967 17.5292,21.8797 17.4262,21.8447 L15.2082,21.1057 C15.1052,21.6917 14.6162,22.1467 14.0002,22.1467 C13.3092,22.1467 12.7502,21.5867 12.7502,20.8967 C12.7502,20.6917 12.8102,20.5057 12.8982,20.3347 L6.6832,18.2627 C6.3542,18.1537 6.1062,17.8817 6.0262,17.5437 C5.9472,17.2067 6.0482,16.8527 6.2932,16.6077 L6.8972,16.0027 C8.2322,14.6687 9.2542,13.0167 9.8512,11.2257 L10.3552,9.7157 C10.7672,8.4787 11.6372,7.4767 12.8042,6.8937 C13.6132,6.4897 14.4982,6.3357 15.3792,6.4087 C15.4802,6.3017 15.5932,6.2047 15.7282,6.1377 C16.0372,5.9827 16.3892,5.9577 16.7192,6.0677 C17.0472,6.1767 17.3132,6.4077 17.4682,6.7167 C17.5362,6.8527 17.5682,6.9977 17.5862,7.1457 C18.3332,7.6157 18.9492,8.2677 19.3542,9.0767 C19.9372,10.2437 20.0312,11.5677 19.6182,12.8047",
    fill: "#FFFFFF"
  }), _react["default"].createElement("path", {
    d: "M15.8984,8.5273 L15.8984,8.5263 C15.1674,8.2823 14.3854,8.3383 13.6974,8.6823 C13.0084,9.0263 12.4964,9.6183 12.2524,10.3483 L11.7484,11.8583 C11.1324,13.7043 10.1294,15.4233 8.8304,16.8703 L16.5444,19.4433 C16.3734,17.5043 16.6034,15.5263 17.2184,13.6813 L17.7204,12.1723 C17.9644,11.4413 17.9094,10.6603 17.5654,9.9713 C17.2204,9.2833 16.6284,8.7703 15.8984,8.5273",
    fill: "#002272"
  }))));
};

var _default = RateAlert;
exports["default"] = _default;